import React from "react";
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';

const EmptyAnnouncements = ({props}) => { 

  return (
       <div className="self-stretch grow shrink basis-0 p-1 flex-col justify-start items-center gap-2 flex">
      <div className="self-stretch px-4 py-3 bg-white rounded-xl border border-stone-300 justify-start items-start gap-2 inline-flex">     
        <div className="grow shrink basis-0 flex-col justify-center items-center gap-1 inline-flex">
            <CampaignRoundedIcon />
            <h4 className="font-semibold ">All Caught up!</h4>
            <h6>There are no new announcements at the moment. Check back later for updates.</h6>
        </div>
      </div>
    </div>
  );
};

export default EmptyAnnouncements;
